import React from "react";
import { ArrowUpRight } from "lucide-react";

const items = [
  {
    img: "https://images.pexels.com/photos/8673896/pexels-photo-8673896.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tag: "Healthcare",
    title: "Aurelius Hospital — Token & OPD Intelligence",
    desc: "Cut average wait time by 41% across 7 departments.",
  },
  {
    img: "https://images.pexels.com/photos/13068380/pexels-photo-13068380.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tag: "Boutique",
    title: "Maison Royale — Salon Queue & Loyalty",
    desc: "Brought no-show rate from 18% to under 5% in one quarter.",
  },
  {
    img: "https://images.unsplash.com/photo-1767277680055-34f1eeec0c26?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBvZmZpY2UlMjBpbnRlcmlvciUyMGRhcmt8ZW58MHx8fHwxNzgxOTUxODYyfDA&ixlib=rb-4.1.0&q=85",
    tag: "Enterprise",
    title: "OrionPay — Custom CRM & AI Voice Agent",
    desc: "Deployed a 24/7 voice agent across 12 markets, in 4 languages.",
  },
  {
    img: "https://images.unsplash.com/photo-1623351143485-b1d4937747f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBvZmZpY2UlMjBpbnRlcmlvciUyMGRhcmt8ZW58MHx8fHwxNzgxOTUxODYyfDA&ixlib=rb-4.1.0&q=85",
    tag: "Government",
    title: "Civic Sphere — Smart Office Token System",
    desc: "Modernized 23 government offices, serving 1.2M citizens annually.",
  },
];

export default function Portfolio() {
  return (
    <section id="portfolio" className="section" data-testid="portfolio-section">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <div>
            <div className="eyebrow mb-4">Portfolio</div>
            <h2 className="font-serif text-4xl md:text-5xl text-white tracking-tight max-w-3xl leading-[1.05]">
              Selected <span className="gold-text italic">work</span>.
            </h2>
          </div>
          <p className="max-w-md text-white/55 text-sm leading-relaxed">
            A curated glance at recent deployments across healthcare, hospitality, finance and government.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {items.map((it, i) => (
            <div key={i} className="group relative overflow-hidden rounded-3xl border border-white/8" data-testid={`portfolio-card-${i}`}>
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={it.img}
                  alt={it.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
              <div className="absolute inset-0 p-7 flex flex-col justify-end">
                <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-gold-300">{it.tag}</div>
                <div className="mt-2 font-serif text-2xl md:text-3xl text-white max-w-md leading-tight">{it.title}</div>
                <div className="mt-2 text-sm text-white/65 max-w-md">{it.desc}</div>
                <div className="mt-4 inline-flex items-center gap-1.5 text-sm text-gold-300">
                  Case study <ArrowUpRight className="h-3.5 w-3.5" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
